import React, { Component } from "react";
import { Link } from "react-router-dom";
class NewsList_SideBar extends Component {
  render() {
    return (
      <div id="sidebar">
        <div
          className="themesflat-spacer clearfix"
          data-desktop={0}
          data-mobile={60}
          data-smobile={60}
        />
        <div id="inner-sidebar" className="inner-content-wrap">
          {/* /.widget_search */}
          <div className="widget widget_follow">
            <Link to="/admin/news-edit">CREATE NEW</Link>
          </div>
        </div>
      </div>
    );
  }
}

export default NewsList_SideBar;
